<template>
	<div class="info-window" :data-testid="`info-window-${location?.mmsClubId}`">
		<div class="d-flex justify-content-between mb-2">
			<div
				class="h6 mb-0 text-uppercase text-nowrap text-truncate"
				:class="{ 'mb-1': location?.comingSoon }"
			>
				{{ location?.clubTitle }}
			</div>

			<button
				type="button"
				class="btn btn-simple py-0 ps-2"
				:data-testid="`close-window-${location?.mmsClubId}`"
				@click="closeWindow"
			>
				<CloseIcon :width="12" :height="12" />
			</button>
		</div>
		<div v-if="location?.comingSoon" class="my-1">
			<span class="badge rounded-pill border px-2">{{ location.comingSoon }}</span>
		</div>

		<div v-if="location?.locationMessage" class="my-1">
			<span class="badge rounded-pill border px-2">{{ location.locationMessage }}</span>
		</div>

		<div class="mb-2">
			{{ location?.street1 }}<br />
			{{ location?.city }}, {{ location?.stateAbbr }}
			{{ location?.zip }}
		</div>

		<div class="d-flex justify-content-between align-items-center">
			<div>
				<a
					v-adobe-data-layer="phonelinkADLConfig"
					class="phone"
					style="text-underline-offset: unset"
					:href="`tel://${location?.phoneLink}`"
					target="_blank"
				>
					{{ location?.phone }}
				</a>
			</div>
			<div>
				<a
					v-adobe-data-layer="detailsADLConfig"
					:href="location?.prospectPagePath"
					class="details btn btn-simple btn-icon focus-ring"
				>
					<ArrowRightParensIcon :width="16" :height="16" /> Details
				</a>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import ArrowRightParensIcon from 'Lib/icons/ArrowRightParensIcon.vue';
import type { Location } from 'Types/aemui/find-a-location/findaLocation';
import vAdobeDataLayer from '@/directives/AdobeDataLayer';
import CloseIcon from 'Lib/icons/CloseIcon.vue';

const props = defineProps<{
	location: Location | null;
}>();

const emit = defineEmits(['closeWindow']);

const closeWindow = () => {
	emit('closeWindow');
};

const detailsADLConfig = {
	name: 'findlocation',
	type: 'link',
	title: 'Details (map)',
	link: props.location?.prospectPagePath
};

const phonelinkADLConfig = {
	name: 'findlocation',
	type: 'link',
	title: props.location?.phone ?? '',
	link: props.location?.phoneLink
};
</script>

<style scoped lang="scss">
.info-window {
	width: 164px;

	@include media-breakpoint-up(sm) {
		width: 200px;
	}
	@include media-breakpoint-up(md) {
		width: 280px;
	}
	@include media-breakpoint-up(lg) {
		width: 200px; // map is half-screen here so needs narrower info window
	}
	@include media-breakpoint-up(xl) {
		width: 280px;
	}

	.badge.rounded-pill {
		font-size: 0.875em;
	}

	.phone {
		font-size: 0.75rem;
	}

	.details {
		font-size: 0.75rem;
	}
}
</style>
